/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import2 from '../../buttons/icon-button/icon-button.component';
import * as import3 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import4 from '../../ui-elements/icon/icon.component';
import * as import5 from 'ng2-translate/src/translate.pipe';
import * as import6 from 'ng2-translate/src/translate.service';
import * as import7 from '../../html-utils/html.pipe';
import * as import8 from '@angular/platform-browser';
import * as import9 from '@angular/common';
import * as import10 from './message.component';
import * as import11 from '../notification.service';
const styles_ContentMessageComponent:any[] = ([] as any[]);
export const RenderType_ContentMessageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ContentMessageComponent,
  data: {}
}
);
function View_ContentMessageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'message-close'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onClose.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.CLOSE;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_ContentMessageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'message-decorator-icon'
      ]
    ],(null as any),(null as any),(null as any),import3.View_IconComponent_0,import3.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import4.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.iconName;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_ContentMessageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'message-body-text'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,2,0,import0.ɵnov((<any>v.parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,1).transform(co.text,co.translationParams))));
    ck(v,0,0,currVal_0);
  });
}
export function View_ContentMessageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import7.HtmlPipe,[import8.DomSanitizer]),
    import0.ɵqud(402653184,1,{messageBody: 0}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContentMessageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import9.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'message-decorator'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContentMessageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import9.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'messageBody',
        1
      ]

    ]
      ,(null as any),6,'div',[[
        'class',
        'message-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContentMessageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import9.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    import0.ɵncd((null as any),1),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.ContentMessageComponent = v.component;
    const currVal_0:any = co.closable;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.showIcon;
    ck(v,8,0,currVal_1);
    const currVal_2:any = co.text;
    ck(v,17,0,currVal_2);
  },(null as any));
}
function View_ContentMessageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_ContentMessageComponent_0,RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import10.ContentMessageComponent,[
      import0.ElementRef,
      import11.NotificationService
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(603979776,1,{links: 1})
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export const ContentMessageComponentNgFactory:import0.ComponentFactory<import10.ContentMessageComponent> = import0.ɵccf('woa-content-message',import10.ContentMessageComponent,View_ContentMessageComponent_Host_0,{
  message: 'message',
  level: 'level',
  icon: 'icon',
  text: 'text',
  translationParams: 'translationParams',
  showIcon: 'showIcon',
  layout: 'layout',
  closable: 'closable',
  actionable: 'actionable'
}
,{onClose: 'onClose'},[
  '*',
  'woa-link'
]
);
const styles_FooterMessageComponent:any[] = ([] as any[]);
export const RenderType_FooterMessageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_FooterMessageComponent,
  data: {}
}
);
function View_FooterMessageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'message-close'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onClose.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.CLOSE;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_FooterMessageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'message-decorator-icon'
      ]
    ],(null as any),(null as any),(null as any),import3.View_IconComponent_0,import3.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import4.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.iconName;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_FooterMessageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'message-body-text'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,2,0,import0.ɵnov((<any>v.parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,1).transform(co.text,co.translationParams))));
    ck(v,0,0,currVal_0);
  });
}
export function View_FooterMessageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import7.HtmlPipe,[import8.DomSanitizer]),
    import0.ɵqud(402653184,1,{messageBody: 0}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FooterMessageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import9.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'message-decorator'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FooterMessageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import9.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'messageBody',
        1
      ]

    ]
      ,(null as any),6,'div',[[
        'class',
        'message-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FooterMessageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import9.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    import0.ɵncd((null as any),1),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.FooterMessageComponent = v.component;
    const currVal_0:any = co.closable;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.showIcon;
    ck(v,8,0,currVal_1);
    const currVal_2:any = co.text;
    ck(v,17,0,currVal_2);
  },(null as any));
}
function View_FooterMessageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-footer-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_FooterMessageComponent_0,RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import10.FooterMessageComponent,[
      import0.ElementRef,
      import11.NotificationService
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(603979776,1,{links: 1})
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export const FooterMessageComponentNgFactory:import0.ComponentFactory<import10.FooterMessageComponent> = import0.ɵccf('woa-footer-message',import10.FooterMessageComponent,View_FooterMessageComponent_Host_0,{
  message: 'message',
  level: 'level',
  icon: 'icon',
  text: 'text',
  translationParams: 'translationParams',
  showIcon: 'showIcon',
  layout: 'layout',
  closable: 'closable',
  actionable: 'actionable'
}
,{onClose: 'onClose'},[
  '*',
  'woa-link'
]
);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/notification/message/message.component.ngfactory.ts